module.exports = __webpack_public_path__ + "static/media/video-cam.99f1cb0f.svg";